import React, {useCallback, useMemo, useState} from 'react';
import {ServiceDetailsDrawer, type ServiceSheetFields} from 'entities/service';
import styles from './ServicesList.module.css';
import {cn} from '@rocket-ui/tools';

export type ServiceListItem = {
	id: string;
	title: string;
	description: string;
	price: string;
	quantity: string;
	unit: string;
	unitPrice: string;
	totalCost: string;
	drawerDescription: string;
	address: string;
};

export type ServicesListProps = {
	items: ServiceListItem[];
};

function toSheetFields(item: ServiceListItem): ServiceSheetFields {
	return {
		title: item.title,
		quantity: item.quantity,
		unit: item.unit,
		unitPrice: item.unitPrice,
		totalCost: item.totalCost,
		description: item.drawerDescription,
		address: item.address,
	};
}

export function ServicesList({items}: ServicesListProps): React.ReactElement {
	const [selectedId, setSelectedId] = useState<string | null>(null);

	const selected = useMemo(
		() => (selectedId == null ? null : items.find((item) => item.id === selectedId) ?? null),
		[items, selectedId],
	);

	const sheetService = selected == null ? null : toSheetFields(selected);

	const handleClose = useCallback(() => {
		setSelectedId(null);
	}, []);

	return (
		<>
			<div className="grid gap-3.5">
				{items.map((item) => (
					<div
						key={item.id}
						className={cn(styles.card, 'cursor-pointer bg-[#85c4ff] p-4 flex flex-col gap-2.5 relative')}
						onClick={() => setSelectedId(item.id)}
					>
						<span className={styles.fold} aria-hidden />
						<span className={styles.fold_transparent} aria-hidden />
						<h3 className="text-xl font-medium">{item.title}</h3>
						<p>{item.description}</p>
						<p className="font-medium">{item.price}</p>
					</div>
				))}
			</div>
			<ServiceDetailsDrawer service={sheetService} onClose={handleClose} />
		</>
	);
}
